import React from "react";
import styled from "styled-components";
import { macOSCheck } from "../../../../util/macOSCheck";

const LineSeedKrRg = (props) => {
  return <LineSeedKrRgWrapper isMac={macOSCheck()} {...props} />;
};

export default LineSeedKrRg;

const LineSeedKrRgWrapper = styled.div`
  font-family: "LINESeedKR-Rg";

  /* font-weight: normal; */
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  text-align: left;
  display: block;
  word-break: keep-all;
  white-space: pre-wrap;

  margin-top: ${(props) => (props.isMac ? "0" : "2px")};
`;
